import type { PriorLeaseBalanceApplyMethod } from '@makemydeal/dr-offer-redux';

export type PriorBalanceApplyMethodOption = {
    value: PriorLeaseBalanceApplyMethod;
    label: string;
    description: string;
};

export const PRIOR_BALANCE_TAB_VALUE = 'prior-balance';
export const PRIOR_BALANCE_TAB_LABEL = 'Prior Balance';

export const PRIOR_BALANCE_INFO_TITLE = 'When to use this';
export const PRIOR_BALANCE_ENABLE_LABEL = 'This lease has remaining scheduled payments to absorb into the new deal';
export const PRIOR_BALANCE_APPLY_METHOD_HEADING = 'How the balance will be applied in the deal';

export const PRIOR_BALANCE_AMOUNT_LABEL = 'Total Remaining Payments Amount';
export const PRIOR_BALANCE_PAYABLE_TO_LABEL = 'Payable To';
export const PRIOR_BALANCE_PAYABLE_TO_PLACEHOLDER = 'Search lender or individual';
export const PRIOR_BALANCE_VIN_LABEL = 'VIN';
export const PRIOR_BALANCE_LENDER_OWED_LABEL = 'Lender Owed';
export const PRIOR_BALANCE_LENDER_OWED_PLACEHOLDER = 'Select Lender...';

export const PRIOR_BALANCE_MAX_AMOUNT = 999999.99;
export const PRIOR_BALANCE_MAX_AMOUNT_MESSAGE = 'Value should be less than 1 million.';

export const CAPITALIZED_OPTION: PriorBalanceApplyMethodOption = {
    value: 'Capitalized',
    label: 'Capitalized',
    description: 'Added to cap cost. Does not affect front-end profit.'
};

export const UPFRONT_OPTION: PriorBalanceApplyMethodOption = {
    value: 'Upfront',
    label: 'Upfront',
    description: 'Collected as part of due-at-signing'
};

export const LEASE_APPLY_METHOD_OPTIONS: PriorBalanceApplyMethodOption[] = [CAPITALIZED_OPTION, UPFRONT_OPTION];

export const NON_LEASE_APPLY_METHOD_OPTIONS: PriorBalanceApplyMethodOption[] = [CAPITALIZED_OPTION];

export const PRIOR_BALANCE_APPLY_METHOD_GROUP_NAME = 'prior-balance-apply-method';
